<template>
  <div class="equipment-control-container">
    <div class="page-content">
      <div class="operation-bar">
        <el-button type="primary" size="mini" @click="handleCreate"
          >+新增</el-button
        >
        <el-button
          type="danger"
          size="mini"
          @click="handleBatchDelete"
          :disabled="!selectedRows.length"
          >删除</el-button
        >
        <div class="search-box">
          <span style="margin-right: 10px; color: #fff">所属企业</span>
          <el-select
            v-model="searchTenantId"
            placeholder="请选择"
            style="width: 200px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in tenantOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span style="margin: 0 10px; color: #fff">所属大棚</span>
          <el-select
            v-model="searchGreenhouseId"
            placeholder="请选择"
            style="width: 200px"
            size="mini"
            clearable
          >
            <el-option
              v-for="item in greenhouseOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            icon="el-icon-search"
            style="margin-left: 10px"
            size="mini"
            type="primary"
            @click="handleSearch"
            >查询</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        height="60vh"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="设备名称"></el-table-column>
        <el-table-column prop="scene" label="所属场景">
          <template slot-scope="scope">
            {{ scope.row.sceneName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="greenhouseName"
          label="所属大棚"
        ></el-table-column>
        <el-table-column prop="tenantName" label="所属企业"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: #2680dd"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              style="color: #ff4d4f"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 设备控制弹窗组件 -->
    <EquipmentControlDialog
      :visible.sync="dialogVisible"
      :is-edit="isEdit"
      :edit-data="editData"
      @submit="handleDialogSubmit"
    />
  </div>
</template>

<script>
import axios from "@/axios";
import { baseUrl } from "@/axios/baseUrl";
import EquipmentControlDialog from "./EquipmentControlDialog.vue";

export default {
  name: "EquipmentControl",
  components: {
    EquipmentControlDialog,
  },
  data() {
    return {
      tableData: [],
      selectedRows: [],
      searchTenantId: "",
      searchGreenhouseId: "",
      page: 1,
      pageSize: 10,
      totalCount: 0,
      dialogVisible: false,
      isEdit: false,
      editData: {},
      tenantOptions: [],
      greenhouseOptions: [],
      sceneMap: {
        1: "场景1",
        2: "场景2",
        3: "场景3",
        4: "场景4",
      },
    };
  },
  created() {
    this.fetchData();
    this.fetchTenantOptions();
    this.fetchGreenhouseOptions();
  },
  methods: {
    // 获取场景名称
    getSceneName(scene) {
      return this.sceneMap[scene] || scene;
    },
    // 获取企业列表
    async fetchTenantOptions() {
      const res = await axios.get(baseUrl + "/api/system/users");
      // 过滤出角色为企业的用户
      const agriTechUsers = res.data.filter(
        (user) =>
          user.roleCodes && user.roleCodes.split(",").includes("company_admin")
      );
      this.tenantOptions = agriTechUsers.map((item) => ({
        label: item.nickName,
        value: item.id,
      }));
    },
    // 获取大棚列表
    async fetchGreenhouseOptions() {
      const formData = new FormData();
      formData.append("enableStatus", 1);
      const greenhouseRes = await axios.post(
        baseUrl + "/api/basic/greenhouse/selection",
        formData
      );
      this.greenhouseOptions = greenhouseRes.data.map((item) => ({
        label: item.serialNumber,
        value: item.id,
      }));
    },
    // 获取设备列表
    async fetchData() {
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          tenantId: this.searchTenantId,
          greenhouseId: this.searchGreenhouseId,
          deviceType: "INTEL_CONTROL_DEVICE",
        };
        const res = await axios.post(
          baseUrl + "/api/device/device-info/list-page",
          params
        );
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;
        }
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    handleCreate() {
      this.isEdit = false;
      this.editData = {};
      this.dialogVisible = true;
    },
    async handleEdit(row) {
      try {
        // 调用详情接口获取完整的设备信息
        const res = await axios.post(
          baseUrl + "/api/device/device-info/detail-by-id",
          {
            id: row.id,
          }
        );
        console.log(res);
        if (res.code === 200 && res.data) {
          this.isEdit = true;
          this.editData = { ...row };
          this.dialogVisible = true;
          // 使用详情接口返回的完整数据更新编辑数据
          this.editData = { ...this.editData, ...res.data };
        }
      } catch (error) {
        console.error("获取设备详情失败:", error);
        this.$message.error("获取设备详情失败");
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除设备 "${row.name}" 吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        const res = await axios.post(
          baseUrl + "/api/device/device-info/delete-batch",
          [row.id]
        );
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.fetchData();
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除失败:", error);
        }
      }
    },
    // 弹窗提交处理
    async handleDialogSubmit(submitData) {
      try {
        let url = "/api/device/device-info/add";
        if (this.isEdit) {
          url = "/api/device/device-info/edit";
        }

        const res = await axios.post(baseUrl + url, submitData);
        if (res.code === 200) {
          this.$message.success(this.isEdit ? "更新成功" : "新增成功");
          this.fetchData();
        }
      } catch (error) {
        console.error("提交失败:", error);
      }
    },
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(
          `确认删除选中的 ${this.selectedRows.length} 个设备吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        const ids = this.selectedRows.map((row) => row.id);
        const res = await axios.post(
          baseUrl + "/api/device/device-info/delete-batch",
          ids
        );
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.fetchData();
        }
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除失败:", error);
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped lang="less">
.equipment-control-container {
  .page-content {
    background: rgba(0, 11, 47, 0.3);
    padding: 20px;
    border-radius: 4px;

    .operation-bar {
      margin-bottom: 20px;
      display: flex;
      align-items: center;

      .search-box {
        margin-left: auto;
        display: flex;
        align-items: center;
      }
    }

    .pagination-container {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
